
import DialogContentText from '@material-ui/core/DialogContentText'

export default DialogContentText